export enum RequestForProposalStatus {
  DRAFT = 1,
  SENT = 2,
  CLOSED = 3
}
